export default "__VITE_ASSET__Fh8Ddp25__"